export interface CouponTerm {
    caption?: string;
    name: string;
    object: string;
    type: CouponTermType;
    products?: ID[];
}

export enum CouponTermType {
    PRODUCTS = "products",
    ARRIVAL_WINDOW = "arrival_window",
    PURCHASE_WINDOW = "purchase_window",
}
